var PnKQuiz = function() {
  const QUIZ_PAGE_SELECTOR = 'quiz-page';
  const QUIZ_FINISH_BUTTON = 'quiz-page-finish-button';
  const CATEGORY_DATA_SELECTOR = 'quiz-json-category-data';
  const QUESTION_DATA_SELECTOR = 'quiz-json-question-data';
  const QUESTION_LIST_SELECTOR = 'quiz-page-question-list';
  const QUESTION_ITEM_SELECTOR = 'quiz-page-question';
  const QUESTION_TITLE_SELECTOR = 'quiz-page-question-title';
  const QUESTION_IMAGE_WRAPPER_SELECTOR = 'quiz-page-question-image-wrapper';
  const ANSWER_LIST_SELECTOR = 'quiz-page-answer-list';
  const ANSWER_ITEM_SELECTOR = 'quiz-page-answer';
  const ANSWER_TITLE_SELECTOR = 'quiz-page-answer-text';
  const ANSWER_IMAGE_WRAPPER_SELECTOR = 'quiz-page-answer-image-wrapper';

  const questionType = {
    SINGLE: 'single',
    MULTIPLE: 'multiple',
  };

  const state = {
    parent: null,
    data: {},
    quiz: {},
    questionsCount: 0,
  }

  const isStartFromLandingPage = !!new URLSearchParams(window.location.search).get('landing');

  return class PnKQuizClass {
    controller = {
      next,
      cleanQuiz,
      store,
      restore,
      definePreferences,
    };

    constructor({ parent }) {
      state.parent = parent;
    }

    init() {
      window.addEventListener('DOMContentLoaded', () => {
        generateQuestions();

        // smartmMart:added experiment: send custom event
        document.dispatchEvent(new CustomEvent('questions:generated'));
      });
    }
  };

  // smartMart:added experiment: don't show Quiz finish page, just go to Taste profile page
  function next(nextQuestionId) {
    const questionId = nextQuestionId > 1 ? nextQuestionId - 1 : 1;

    answer(`${QUESTION_ITEM_SELECTOR}-${questionId}`, ANSWER_ITEM_SELECTOR);

    if (questionId === state.questionsCount) {
      saveQuiz();

      // User just finished a fresh quiz — they've earned the 50€ offer,
      // so clear the "restored session" flag that hides the banner.
      try {
        sessionStorage.removeItem('winely_restored_session');
        document.documentElement.classList.remove('winely-restored');
      } catch (e) {}

      let userPrefs = [];
      try {
        userPrefs = Object.values(definePreferences()).flatMap(p => p.values || []);
      } catch (e) {
        console.error('[winely] definePreferences error:', e);
      }
      document.dispatchEvent(new Event('quiz:finished'));

      // Seamless re-quiz: if email is already known (logged-in customer or
      // restored from a previous quiz), persist it so finishQuiz() can rely on
      // pnk.quizController instead of the (about-to-be-skipped) DOM input.
      const knownEmail =
        (window.winelyCustomer && window.winelyCustomer.email) ||
        restore('data.email');
      if (knownEmail) {
        store('data.email', knownEmail);
      }

      // Send the known email so the backend can update the existing row in
      // place on a re-quiz (keeps qid stable, drops "pending" duplicates).
      var submitEmail = null;
      try {
        submitEmail = localStorage.getItem('winely_email')
          || (window.winelyCustomer && window.winelyCustomer.email)
          || (knownEmail || null);
      } catch (e) {}

      // Honeypot: if the hidden field on the start form was filled, a bot
      // got past the click guard somehow. Pass it through; the backend
      // returns a fake-success response without persisting.
      var honeypotValue = '';
      try {
        var hp = document.querySelector('.quiz-page-start-form input[name="customer[website]"]');
        if (hp) honeypotValue = hp.value || '';
      } catch (e) {}

      // Storefront locale — drives which language Klaviyo sends emails in.
      // `window.Shopify.locale` is the storefront-level setting (e.g. 'de',
      // 'en'); fall back to the `<html lang>` attribute, which Shopify also
      // populates per active language.
      var submitLocale = null;
      try {
        submitLocale = (window.Shopify && window.Shopify.locale)
          || (document.documentElement && document.documentElement.lang)
          || null;
      } catch (e) {}

      // Partner attribution — set by the partner landing page (window.winelyPartner).
      // Absent on the plain /pages/quiz, so it stays undefined there.
      var submitPartner = null;
      try {
        submitPartner = (window.winelyPartner && window.winelyPartner.slug) || null;
      } catch (e) {}

      fetch('https://winely-backend.vercel.app/api/quiz/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          raw_answers: state.quiz,
          recommended_product_ids: [],
          user_preferences: userPrefs,
          categories: state.data.categories || {},
          email: submitEmail || undefined,
          honeypot: honeypotValue || undefined,
          locale: submitLocale || undefined,
          partner: submitPartner || undefined,
        }),
      })
        .then(r => r.json())
        .then(data => {
          const { qid } = data;
          console.log('[winely] quiz submit — qid:', qid);
          if (qid) {
            localStorage.setItem('winely_qid', qid);
          }
          finishQuiz();
        })
        .catch(e => {
          console.error('[winely] submit error:', e);
          finishQuiz();
        });
    }
  }

  function saveQuiz(done = () => {}, fail = () => {}, errorMessage = null) {
    const { quiz } = state;
    const preferences = definePreferences();

    if (!isStartFromLandingPage) {
      window.Flits?.setCustomFieldsData({ wine_preferences: '{}' }) // need clean before save big datas
        .then(() => {
          window.Flits?.setCustomFieldsData({
            wine_preferences: JSON.stringify({ quiz, preferences }),
          })
        })
        .done(done)
        .fail((...props) => {
          fail(props);
          console.error(
            errorMessage ||
              'Error save quiz results to server. Perhaps you must be a registered. Still quiz results save to a local storage.'
          );
        })
        .always(activateGotoTasteProfileButton);
    }

    store('result', quiz);
    store('preferences', preferences);
  }

  function activateGotoTasteProfileButton() {
    const finishButton = document.querySelector(`.${QUIZ_FINISH_BUTTON}`);

    if (!finishButton) return;

    finishButton.textContent = finishButton.dataset.finishText || 'Done';
    finishButton.classList.remove('loading');
    finishButton.disabled = false;
  }

  function answer(questionSelector, answerSelector) {
    const questionBody = document.querySelector(`.${questionSelector}`);
    const answers = [...(questionBody?.querySelectorAll(`.${answerSelector} input`) || [])]
      .filter(({ checked }) => Boolean(checked));
    const category = answers[0].dataset.category;
    const points = answers.map(({ dataset }) => dataset.points).filter(Boolean);

    if (!category || !points.length) return;

    state.quiz = {
      ...state.quiz,
      [category]: [...(state.quiz[category] || []), ...points],
    };

    window.scrollTo(0, 0);
  }

  function cleanQuiz() {
    const storageName = isStartFromLandingPage ? 'landing' : 'quiz';
    const storage = JSON.parse(localStorage[storageName] || '{}');

    state.quiz = {};
    if (isStartFromLandingPage) {
      delete storage.quiz?.result;
    } else {
      delete storage.result;
    }
    localStorage[storageName] = JSON.stringify(storage);
  }

  function generateQuestions() {
    const { parent } = state;
    const root = document.querySelector(`.${QUIZ_PAGE_SELECTOR}`);
    const questionDatas = [...document.querySelectorAll(`.${QUESTION_DATA_SELECTOR}`)];
    const nodeQuestions = root?.querySelector(`.${QUESTION_LIST_SELECTOR}`);
    const templateQuestion = nodeQuestions?.querySelector('template');

    if (!root || !parent || !questionDatas.length || !nodeQuestions || !templateQuestion) return;

    const questions = questionDatas.map(({ textContent }) => JSON.parse(textContent));
    const { categories } = state.parent.getJsonDataFrom(`.${CATEGORY_DATA_SELECTOR}`);

    state.data = {
      categories,
      questions,
    };

    // Save categories to localStorage so taste-profile can recalculate preferences on magic link restore
    store('categories', categories);

    const questionsCount = state.data.questions.length;
    state.questionsCount = questionsCount;
    parent.setAlpineData('quizQuestionsCount', questionsCount);

    state.data.questions.forEach(({ question, answers }, questionId) => {
      const itemQuestion = templateQuestion?.content.cloneNode(true).querySelector(`.${QUESTION_ITEM_SELECTOR}`);

      if (!itemQuestion) return;

      questionId++;

      itemQuestion.classList.add(`${QUESTION_ITEM_SELECTOR}-${questionId}`);
      itemQuestion.setAttribute('x-show', `quizStep === ${questionId}`);

      const caption = itemQuestion.querySelector('h3');
      if (caption)
        caption.textContent = caption.textContent
          .replace('[question_number]', questionId)
          .replace('[questions_count]', questionsCount);

      const title = itemQuestion.querySelector(`.${QUESTION_TITLE_SELECTOR}`);
      if (title)
        title.textContent = question.text;

      const imageWrapper = itemQuestion.querySelector(`.${QUESTION_IMAGE_WRAPPER_SELECTOR}`);
      if (imageWrapper && question.image?.length > 0)
        parent.renderImage({
          parent: imageWrapper,
          src: question.image,
          imgClassnames: 'w-full h-full object-contain',
          lazy: false,
        });
      else
        imageWrapper.remove();

      const nodeAnswers = itemQuestion.querySelector(`.${ANSWER_LIST_SELECTOR}`);
      const templateAnswer = nodeAnswers.querySelector('template');

      if (nodeAnswers)
        answers.forEach((answer, answerId) => {
          const itemAnswer = templateAnswer?.content.cloneNode(true).querySelector(`.${ANSWER_ITEM_SELECTOR}`);

          if (!itemAnswer) return;

          answerId++;

          const answerTitle = itemAnswer.querySelector(`.${ANSWER_TITLE_SELECTOR}`);
          if (answerTitle)
            answerTitle.textContent = answer.text;

          const answerImageWrapper = itemAnswer.querySelector(`.${ANSWER_IMAGE_WRAPPER_SELECTOR}`);
          if (answerImageWrapper && answer.image?.length > 0)
            parent.renderImage({
              parent: answerImageWrapper,
              src: answer.image,
              imgClassnames: 'w-full h-full object-contain',
              lazy: false,
            });
          else
            answerImageWrapper.remove();

          const radioInput = itemAnswer.querySelector('input[type=radio]');
          const checkboxInput = itemAnswer.querySelector('input[type=checkbox]');
          const inputBuilder = {
            [questionType.SINGLE]: () => {
              if (checkboxInput)
                checkboxInput.remove();

              if (!radioInput) return;

              radioInput.name = `quiz-q${questionId}`;
              radioInput.dataset.points = answer.points;
              radioInput.dataset.category = answer.category;
              radioInput.setAttribute(
                'x-on:click',
                `canNext = true; store('data.q${questionId}', [${answerId}]); next(++quizStep);`
              );
              radioInput.setAttribute('x-bind:checked', `isAnswerSelected('q${questionId}', ${answerId})`);
            },

            [questionType.MULTIPLE]: () => {
              if (radioInput)
                radioInput.remove();

              if (!checkboxInput) return;
            },
          };
          inputBuilder[question.type]();

          nodeAnswers.appendChild(itemAnswer);
        });

      nodeQuestions.appendChild(itemQuestion);
    });
  }

  function definePreferences(rawAnswers, rawCategories) {
    const categories = rawCategories || state.data?.categories;
    const quiz = rawAnswers || state.quiz;

    const uniq = (arr) => arr.reduce((a, v) => (a.includes(v) ? a : [...a, v]), []);
    const sum = (arr) => arr.reduce((a, v) => a + v, 0);

    const categoryPoints = Object.entries(quiz).reduce((acc, [category, points]) => {
      if (!categories[category]) {
        console.error(`The category '${category}' of quiz categories '${Object.keys(categories)}' does not exist.`);
        return acc;
      }

      const summaryPoints = points.reduce((acc, point) => acc + Number(point), 0);

      return {
        ...acc,
        [category]: summaryPoints,
      };
    }, {});

    const preferences = Object.entries(categoryPoints).reduce((acc, [category, points]) => {
      const types = categories[category];
      const valuables = [];

      const categoryValues = types.reduce((acc, categoryValue) => {
        const { from, to, values, valuable, type } = categoryValue;

        if (points < from || points > to) return acc;

        valuables.push(valuable);

        return {
          values: [...acc.values, ...values],
          types: [...acc.types, type],
        };
      }, { values: [], types: [] });

      return {
        ...acc,
        [category]: {
          values: [...(acc[category]?.values || []), ...uniq(categoryValues.values)],
          valuable: sum(valuables),
          types: [...(acc[category]?.types || []), ...uniq(categoryValues.types)],
        },
      };
    }, {});

    return preferences;
  }

  function store(key, value) {
    if (isStartFromLandingPage) {
      state.parent.store('landing', `quiz.${key}`, value)
    } else {
      state.parent.store('quiz', key, value);
    }
  }

  function restore(key) {
    return isStartFromLandingPage
      ? state.parent.restore('landing', key ? `quiz.${key}` : 'quiz')
      : state.parent.restore('quiz', key);
  }
}();